import React, { Component } from "react";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { HeaderFilter } from "../../../common/header-filter/header-filter.component";
import { DataTable } from "../../../common/table/data-table/data-table-component";
import DisputeDetails from "./details/dispute-details.component";
import { Header_Filter_Button_Label } from "../../../../constants/internal-constants";
export class Dispute extends Component {
    constructor(props) {
        super(props);
        this.state={
            viewDetailPage:false
        }
    }
    getData=(value)=>{
		this.setState({viewDetailPage:value})
	}
    render() {
        const dropdownItem = ["Item 1", "Item 2", "Item 3"]
        const dataTable = [
            {
                HeaderItem: [
                    {
                        name: "Contract Name"
                    },
                    {
                        name: "Vendor"
                    }, {
                        name: "Status"
                    }, {
                        name: "Service Type"
                    }, {
                        name: "Effective Date"
                    }, {
                        name: "Expiration Date"
                    }
                ],
                dataItem: [{
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }
                ]

            }
        ]
        const pages = {
            HasNext: true,
            HasPrevious: false,
            PageNumber: 0,
            PerPage: 21,
            TotalEntries: 2453,
            TotalPages: 123

        }
        const listItem = [
            {
                listTitle: "Plan",
                href: "#"
            }
            , {
                listTitle: "Feature"
                , href: "#"
            }
            , {
                listTitle: "Rate"
                , href: "#"
            }
        ];
        return (
            <>
                <RequestHeaders headerTitle="Dispute" />
                {this.state.viewDetailPage ? 
                 <DisputeDetails closeForm={this.getData.bind(this)}/>
                :
                <div className="request-table data-table internal-data-table">
                    <HeaderFilter enableDropdown={true} dropdownItem={dropdownItem} enableExportExcel={false} btnAddTitle={Header_Filter_Button_Label.AddDispute} enableAddBtn={true} enableUploadBtn={false} listItem={listItem} haveTab={false} />
                    {dataTable.map((item, id) =>
                        <DataTable key={id} id={id} item={item} header={item.HeaderItem} data={item.dataItem} getData={this.getData} isDataLoaded={true} customClassName="table-container" pages={pages} havePagination={true} />
                    )}
                </div>

                }
                
               
            </>
        )
    }
}